import React from 'react'
import LeftBar from '../../Components/LeftBar'
import Dashnav from '../../Components/Dashnav'
import PayBillsComp from './PayBillsComp'

function PayBills() {
  return (
    <div className='mainContainer'>
      <LeftBar />
      <div className='theMainContainer'>
        <Dashnav />
        <PayBillsComp />
      </div>
    </div>
  )
}

export default PayBills
